// Prefetches all admin page chunks in the background so that navigating
// between admin dashboards is instant (no network round-trip for the JS chunk).
// Safe to call multiple times - dynamic imports are cached by the browser.

let prefetched = false;

export function prefetchAdminRoutes() {
  if (prefetched) return;
  prefetched = true;

  // Fire-and-forget. Use requestIdleCallback when available so we don't
  // contend with the current page's render work.
  const run = () => {
    void import('@/pages/AdminUsers');
    void import('@/pages/AdminTransactions');
    void import('@/pages/AdminReporting');
    void import('@/pages/AdminInsights');
    void import('@/pages/AdminArticles');
    void import('@/pages/AdminQuestionEditor');
    void import('@/pages/AdminUserMetrics');
    void import('@/pages/AdminChat');
    void import('@/pages/AdminPlatformUsage');
  };

  if (typeof (window as any).requestIdleCallback === 'function') {
    (window as any).requestIdleCallback(run, { timeout: 2000 });
  } else {
    setTimeout(run, 300);
  }
}
